import type { VoiceMessage } from "./types"

export function isVoiceMessage(value: unknown): value is VoiceMessage {
	return (
		typeof value === "object" &&
		value !== null &&
		"version" in value &&
		"phase" in value
	)
}
